import template from './branches_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AdminBranchesComponentViewModel
{
	constructor(bindings)
	{
		this.branches = ko.observableArray();
		this.bindings = bindings;

		this.save_branch = this.save_branch.bind(this);
		this.delete_branch = this.delete_branch.bind(this);

		this.init();
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'branch',
			schema: 'public',
			limit: 1000000
		});

		if (res.status !== 'ERROR')
		{
			if (res.records)
				this.branches(res.records);
		}
		else
			Grape.alerts.apiError(res);

		Utils.refresh_data_visible_roles();
	};

	async init()
	{
		this.updateData();
	};

	edit_branch(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();

		view_row.hide();
		edit_row.show();
	};

	async delete_branch(v, e)
	{
		let edit_row = $(e.currentTarget).parent().parent().parent();
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this branch entry? ')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/branches/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted branch.'), title: tr('Success') });
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};

	async save_branch(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		if (data.branch_id == '')
			data.branch_id = null;

		let res = await Grape.fetches.postJSON('/admin/branches/edit', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully saved branch.'), title: tr('Success') });
			this.updateData();
			edit_row.hide();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
			this.updateData();
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

		view_row.show();
		edit_row.hide();
	};

	add_branch(v, e)
	{
		let branches = v.branches;

		branches.unshift({
			department: '',
			branch: '',
			branch_id: ''
		});

		let row = $('#branch_body > tr:first-child');
		row.hide();
		row.next().show();
	}

	cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
		this.updateData();
	}
}

export default {
	name: 'branches_component',
	viewModel: AdminBranchesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/branches_component'
};
